import React from 'react';
import { BrowserRouter, Route, Switch, withRouter } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import AuthPage from '../pages/auth/AuthPage';
import MainPage from '../pages/main/MainPage';
import NotFoundPage from '../pages/error/NotFoundPage';
import ClickErrorPage from '../pages/clickError/ClickErrorPage';
import ModalRoot from '../components/Modal/ModalRoot';
import Footer from '../components/Footer/Footer';

const AppRouterContent = ({ intl, location }) => {
  const { locale } = intl;

  return (
    <div id="layout" className={locale ? locale : ''}>
      <Switch>
        <Route path="/" component={MainPage} exact />
        <Route path="/publisher" component={AuthPage} exact />
        <Route path="/publisher/:type" component={AuthPage} exact />
        <Route path="/recovery" component={AuthPage} exact />
        <Route path="/click-error" component={ClickErrorPage} exact />
        <Route component={NotFoundPage} />
      </Switch>
      <Footer />
      <ModalRoot />
    </div>
  );
};

const AppRouter = injectIntl(withRouter(AppRouterContent));

const App = () => (
  <BrowserRouter>
    <AppRouter />
  </BrowserRouter>
);

export default App;
